import script from "./user-info-edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-info-edit.vue?vue&type=script&setup=true&lang=ts"

import "./user-info-edit.vue?vue&type=style&index=0&id=2d4c53f7&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4c53f7"]])

export default __exports__